import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'arrow-backlink',
  templateUrl: './arrow-link.component.html',
  styleUrls: ['./arrow-link.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ArrowBackLinkComponent {
  @Input() public url: string;
  @Input() public text: string;
}
